<template>
  <div class="contact">
    <div class="container">
      <h1 class="page-title">{{ $t('contact.title') }}</h1>
      
      <div class="placeholder-content">
        <el-empty :description="$t('contact.redirecting')">
          <template #image>
            <img src="@/assets/images/contact-us.svg" :alt="$t('contact.contactUsAlt')" class="contact-image">
          </template>
          <el-button type="primary" @click="openTelegramLink">{{ $t('contact.contactNow') }}</el-button>
        </el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'ContactView',
  setup() {
    const telegramLink = 'https://t.me/BelugaWhaleSMSBot'
    
    const openTelegramLink = () => {
      window.open(telegramLink, '_blank', 'noopener,noreferrer')
    }
    
    onMounted(() => {
      // 自动跳转到Telegram链接
      openTelegramLink()
    })
    
    return {
      openTelegramLink
    }
  }
}
</script>

<style scoped>
.contact {
  padding: 40px 0;
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #333;
}

.placeholder-content {
  margin: 100px 0;
  display: flex;
  justify-content: center;
}

.contact-image {
  width: 200px;
  height: auto;
}
</style> 